import { render, staticRenderFns } from "./ToggleSwitchOff.vue?vue&type=template&id=6fef93ab&"
import script from "./ToggleSwitchOff.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitchOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fef93ab')) {
      api.createRecord('6fef93ab', component.options)
    } else {
      api.reload('6fef93ab', component.options)
    }
    module.hot.accept("./ToggleSwitchOff.vue?vue&type=template&id=6fef93ab&", function () {
      api.rerender('6fef93ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/ToggleSwitchOff.vue"
export default component.exports